import React, { useState, useEffect } from "react";
import { Box, TextField, InputAdornment, IconButton, useMediaQuery, } from "@mui/material";
import { ArrowDown2, Calendar } from "iconsax-react";
import { Controller, useWatch, } from "react-hook-form";
import DatePicker, { DateObject } from "react-multi-date-picker";
import dayjs from "dayjs";
import { ErrorMessage } from "../inputs/ValidationMessage";
import "../../../App.css";
import "./style.css";
import "./style.css";
export const FDateRangePickerField = ({ name, control, label, error, helperText, required = false, handleSelectedRange, showMonths = 2, value, }) => {
    const isSm = useMediaQuery((theme) => theme.breakpoints.down("sm"));
    const [values, setValues] = useState([]);
    const [hasInitialized, setHasInitialized] = useState(false);
    // Watch the form field value
    const fieldValue = useWatch({ control, name });
    // Sync local state with external value prop (string format)
    useEffect(() => {
        if (value && typeof value === "string" && value.includes(",")) {
            const [startDate, endDate] = value.split(",");
            if (startDate && endDate) {
                const startDateObj = new DateObject(dayjs(startDate).toDate());
                const endDateObj = new DateObject(dayjs(endDate).toDate());
                setValues([startDateObj, endDateObj]);
                setHasInitialized(true);
            }
        }
        else if (!value || value === "") {
            // Clear values when filter is cleared (but only if initialized)
            if (hasInitialized) {
                setValues([]);
            }
        }
    }, [value, hasInitialized]);
    // Initialize from form's default value (Date array) on mount
    useEffect(() => {
        // Only initialize once and only if we have a valid date array
        if (hasInitialized)
            return;
        if (Array.isArray(fieldValue) && fieldValue.length === 2) {
            const dateArray = fieldValue;
            const startDate = dateArray[0];
            const endDate = dateArray[1];
            // Check if they are Date objects or can be converted to dates
            let startDateObj = null;
            let endDateObj = null;
            if (startDate instanceof Date && !isNaN(startDate.getTime())) {
                startDateObj = new DateObject(startDate);
            }
            else if (startDate && typeof startDate === 'object' && 'getTime' in startDate) {
                // Handle date-like objects
                startDateObj = new DateObject(new Date(startDate.getTime()));
            }
            if (endDate instanceof Date && !isNaN(endDate.getTime())) {
                endDateObj = new DateObject(endDate);
            }
            else if (endDate && typeof endDate === 'object' && 'getTime' in endDate) {
                // Handle date-like objects
                endDateObj = new DateObject(new Date(endDate.getTime()));
            }
            if (startDateObj && endDateObj) {
                setValues([startDateObj, endDateObj]);
                setHasInitialized(true);
            }
        }
    }, [fieldValue, hasInitialized]);
    const handleDateRangeValues = (selectedDates, formField) => {
        setValues(selectedDates);
        setHasInitialized(true);
        if (selectedDates.length === 2) {
            const fromDate = selectedDates[0].toDate();
            const toDate = selectedDates[1].toDate();
            // Update form field if provided
            if (formField === null || formField === void 0 ? void 0 : formField.onChange) {
                formField.onChange([fromDate, toDate]);
            }
            handleSelectedRange(dayjs(fromDate).format("YYYY-MM-DD"), dayjs(toDate).format("YYYY-MM-DD"));
        }
        else if (selectedDates.length === 0) {
            // Update form field if provided
            if (formField === null || formField === void 0 ? void 0 : formField.onChange) {
                formField.onChange([]);
            }
            // Handle clearing the date range
            handleSelectedRange("", "");
        }
    };
    const getValidationMessage = (fieldError) => (fieldError === null || fieldError === void 0 ? void 0 : fieldError.message) || helperText;
    return (React.createElement(Controller, { name: name, control: control, render: ({ field, fieldState: { error: fieldError } }) => (React.createElement(Box, { width: "100%" },
            React.createElement(DatePicker, { range: true, rangeHover: true, calendarPosition: "top", className: "h-date-range-picker", portal: true, numberOfMonths: isSm ? 1 : showMonths, showOtherDays: true, containerStyle: { width: "100%" }, value: values, onChange: (dates) => handleDateRangeValues(dates, field), format: "DD / MM / YYYY", zIndex: 1400, render: (value, openCalendar) => (React.createElement(Box, { width: "100%" },
                    React.createElement(TextField, { fullWidth: true, variant: "filled", label: React.createElement(React.Fragment, null,
                            label,
                            required && (React.createElement("span", { style: { color: "#FF0000" } }, "\u00A0*"))), value: value, onClick: (e) => {
                            openCalendar();
                        }, InputProps: {
                            readOnly: true,
                            endAdornment: (React.createElement(InputAdornment, { position: "end" },
                                React.createElement(IconButton, { onClick: openCalendar },
                                    React.createElement(ArrowDown2, { color: "#454F5B", size: 16 })))),
                            startAdornment: (React.createElement(InputAdornment, { position: "start" },
                                React.createElement(Calendar, { size: 20, onClick: openCalendar, color: "#454F5B" }))),
                        }, sx: {
                            "&.MuiInputBase-root": {
                                paddingLeft: 0,
                            },
                        }, error: !!fieldError || !!error }))) }),
            React.createElement(ErrorMessage, { error: getValidationMessage(fieldError || error) }))) }));
};
